import { useQuery } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import apiClient from "@/modules/request.module.v2";
import { ROUTES } from "@/constants/routes";

const reservedRoutes = Object.values(ROUTES).map((route) => route.substring(1));

const useCompanyIdFromUrl = () => {
  const urlAlias = getCompanyUrlAliasFromUrl();

  const query = useQuery({
    enabled: !!urlAlias,
    staleTime: Infinity, // No need to refetch this data once we have the company ID
    queryKey: ["companyIdByAlias", urlAlias],
    queryFn: () => {
      return apiClient.get(`companies/${urlAlias}?alias=true`);
    },
  });

  return query?.data?.data?.id;
};

const isReservedRoute = (routeName) => reservedRoutes.includes(routeName);

export const getCompanyUrlAliasFromUrl = () => {
  const routeMatch = useRouteMatch("/:urlAlias");
  const routeName = routeMatch?.params?.urlAlias;
  return !isReservedRoute(routeName) ? routeName : null;
};

export { useCompanyIdFromUrl };
